const TRACKED_FIELDS = [
  'locationName',
  'specificLocation',
  'civicAddress',
  'numOfUOS',
  'numOfSSR',
  'numSwitches',
  'switches',
];

export const snapshotSysIdForm = (form) =>
  JSON.stringify(TRACKED_FIELDS.map((field) => form?.[field] ?? null));

export const isSysIdFormDirty = (snapshot, form) => {
  if (!snapshot) return false;
  return snapshot !== snapshotSysIdForm(form);
};
